<template>
    <label class="def-radio-checkout">
        <input
            :name="name"
            :value="value"
            :checked="checked"
            type="radio"
            class="def-radio-checkout__input"
            :class="{'collapsed checked': checked }"
        >
        <span class="def-radio-checkout__checkbox"></span>
        <span class="def-radio-checkout__text">
            <slot />
        </span>
    </label>
</template>

<script>
export default {
    name: 'DefRadioCheckout',
    selector: '.def-radio-checkout',
    props: ['name', 'value', 'checked'],
}
</script>

<style lang="scss" scoped>
.def-radio-checkout{
    display: inline-flex;
    cursor: pointer;
    &__input{
        display: none;
        &:checked + .def-radio-checkout__checkbox{
            border-color: var(--background-black);
            /*border: 1px solid #c5c4be;*/
            &:before{
                background-color: var(--background-black);
                /*background-color: #f1c7c2;*/
            }
        }
    }
    &__checkbox{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1px solid var(--border-grey);
        transition: .2s linear border-color;
        flex-shrink: 0;
        &:before{
            content: '';
            width: 12px;
            height: 12px;
            background-color: transparent;
            border-radius: 50%;
            transition: .2s linear background-color;
        }
    }
    &__text{
        width: 100%;
        margin-left: 12px;
    }
}
</style>